import type React from "react";

import type { PanelSource } from "../../lib/analytics";
import type { CaseListFilters } from "../../screens/cases/utils/types";

export const CASES_PANEL_WIDTH = 380;

export const CASES_PANEL_WIDTH_COMPACT = 300;

export const getCasesPanelWidth = (media: { gtMd: boolean }): number =>
  media.gtMd ? CASES_PANEL_WIDTH : CASES_PANEL_WIDTH_COMPACT;

export type CasesPanelContextInterface = CaseListFilters & {
  isOpen: boolean;
  togglePanel: (source: PanelSource, open?: boolean) => void;
  isOnCasesPage: boolean;
  setFilters: (filters: CaseListFilters) => void;
};

export type CasesPanelProviderProps = {
  children: React.ReactNode;
};
